import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Mail, SendHorizonal, PenSquare, Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Tabs, TabPanel } from "@/components/ui/Tabs";
import { Inbox } from "@/features/messaging/Inbox";
import { SentMessages } from "@/features/messaging/SentMessages";
import { ComposeMessage } from "@/features/messaging/ComposeMessage";
import { MessageCenter } from "@/features/messaging/MessageCenter";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const tabs = [
  { id: "inbox", label: "Inbox", icon: Mail },
  { id: "sent", label: "Sent", icon: SendHorizonal },
  { id: "compose", label: "Compose", icon: PenSquare },
  { id: "notifications", label: "Notifications", icon: Bell },
];

export function MessagingPage() {
  const [activeTab, setActiveTab] = useState("inbox");

  const { data: unreadData } = useQuery<{ data: { count: number } }>({
    queryKey: ["messaging", "unread-count"],
    queryFn: () =>
      api.get<{ data: { count: number } }>("/messaging/unread-count"),
  });

  const unreadCount = unreadData?.data?.count ?? 0;

  // Augment inbox tab label with unread count
  const displayTabs = tabs.map((t) => {
    if (t.id === "inbox" && unreadCount > 0) {
      return { ...t, label: `Inbox (${unreadCount})` };
    }
    return t;
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Messages</h1>
        <p className="text-sm text-muted-foreground">
          Internal messaging and notification center.
        </p>
      </div>

      <Tabs tabs={displayTabs} activeTab={activeTab} onChange={setActiveTab} />

      <TabPanel id="inbox" activeTab={activeTab}>
        <Inbox />
      </TabPanel>

      <TabPanel id="sent" activeTab={activeTab}>
        <SentMessages />
      </TabPanel>

      <TabPanel id="compose" activeTab={activeTab}>
        <ComposeMessage />
      </TabPanel>

      <TabPanel id="notifications" activeTab={activeTab}>
        <MessageCenter />
      </TabPanel>
    </div>
  );
}
